<template>
  <Modal ref="parent" @close="$emit('close')">
    <div class="relative">
      <div class="flex justify-between">
        <div>
          <img v-if="logo" :src="logo" alt="" class="h-16" />
        </div>
        <button type="button" class="p-2" @click="close">
          <XIcon />
        </button>
      </div>

      <p class="text-center font-medium mb-2 text-xl">{{ title }}</p>
      <PayMeCode :text="text" :img="img" v-if="isPayMe" />
      <img v-else :src="qrurl" alt="QR Code" :class="['mx-auto', 'size-80']" />
      <p class="text-center tracking-wide mt-4 text-gray-400 text-sm mb-8">
        {{ subject }}
      </p>

      <div class="border-t py-4">
        <p class="mb-4">{{ tips }}</p>
        <ul class="text-sm space-y-2" v-if="steps">
          <li class="guideline" v-for="(step, index) in steps" :key="index">
            <span class="step">{{ index + 1 }}</span
            ><span class="flex-grow">{{ step }}</span>
          </li>
        </ul>
      </div>
    </div>
  </Modal>
</template>

<script>
import { XIcon } from "@vue-hero-icons/outline";
import PayMeCode from "./PayMeCode.vue";
import qrcode from "qrcode";
export default {
  components: {
    PayMeCode,
    XIcon,
  },
  props: {
    title: String,
    subject: String,
    tips: String,
    steps: Array,
    logo: String,
    text: String,
    img: String,
    payCode: String,
  },
  data() {
    return {
      qrurl: "",
    };
  },
  methods: {
    paied() {},
    close() {
      this.$refs.parent.close();
    },
  },
  computed: {
    isPayMe() {
      return this.payCode === "payme";
    },
  },
  mounted() {
    if (!this.isPayMe) {
      qrcode.toDataURL(this.text).then((url) => {
        this.qrurl = url;
      });
    }
  },
};
</script>

<style lang="css" scoped>
.step {
  @apply bg-gray-600 rounded-full text-white font-bold w-6 h-6 flex justify-center flex-none items-center mr-2;
}

.guideline {
  @apply flex items-start justify-start;
}
</style>
